<template>
    <div class="topicIndex spackage padding-20 bgc box-shadow">
        <!-- start 顶部菜单栏 -->
        <section class="startMgt-header">
            <el-date-picker class="item" v-model="time.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-input placeholder="输入关键字" v-model="searchName" style="width: 240px"></el-input>
            <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
        </section>
        <!-- end 顶部菜单栏 -->
        <section>
            <el-table :data="CommentData">
                <el-table-column prop="customername" label="评论人" align="center">
                    <template slot-scope="scope">
                        <div class="customerBox">
                            <img :src="scope.row.headimageurl">
                            <span class="recommon">{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="subject" label="帖子标题/内容" align="center" width="300"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="content" label="评论内容" align="center"></el-table-column>
                <el-table-column prop="datetime" label="评论时间" align="center"></el-table-column>
                <el-table-column label="操作" align="right" class-name="table-position">
                    <template slot-scope="scope">
                        <span @click="commentDetails(scope.row.contentinnerid,scope.row.sourceinnerid)">回复</span>
                        <span>｜</span>
                        <span @click="delClick(scope.row.contentinnerid)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </section>
    </div>
</template>

<script>
    import {getCommentList,delComment} from '@/api/communityApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters,mapActions} from 'vuex'
    import Page from 'base/page/page'
    import fecha from 'element-ui/src/utils/date';
    export default {
        name: "commentMgt",
        data() {
            return {
                starinnerid: this.$route.query.innerid,
                value1: '', //日期
                CommentData:[], //列表数据
                total:0,
                time: {             // 开始/结束时间
                    date: ''
                },
                searchName:'' //搜索文字
            }
        },
        components: {
            Loading,
            Page
        },
        mounted() {
            this.setLoading(true);
            this.apiData = {
                starinnerid:this.$route.query.innerid,
                page: 1,
                pageSize: 10
            };
            this.commentListEvent()
        },
        methods: {
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            commentDetails(id,sourceinnerid){
                console.log(id);
                this.$router.push({name: 'PlanetCommunityCommentDetails', query:({innerid: id,starinnerid:this.starinnerid,sourceinnerid:sourceinnerid})})
            },
            ...mapActions([
                'setLoading'
            ]),
            //评论列表
            commentListEvent() {
                getCommentList({
                    data: this.apiData,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.CommentData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                    }
                })
            },
            // 删除评论
            delClick(id) {
                this.$confirm('删除后将不可恢复，确认删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let params = {
                        innerid:id,
                    };
                    this.setLoading(true);
                    delComment({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this.commentListEvent();
                            this.$message.success(`删除成功!`)
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            // 搜索
            searchClick() {
                this.setLoading(true);
                let searchDate = this.time;
                let params = {
                    starinnerid:this.$route.query.innerid,
                    keyword: this.searchName,
                    beginTime:searchDate.date[0]?fecha.format(searchDate.date[0], 'yyyy-MM-dd'):'',
                    endTime:searchDate.date[1]?fecha.format(searchDate.date[1], 'yyyy-MM-dd'):'',
                };
                getCommentList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.CommentData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false)
                    }
                })
            },
        },
        computed: {
            ...mapGetters([
                'page',
                'user'
            ])
        },
    }
</script>

<style scoped lang="scss">
    .topicIndex {
        display: flex;
        flex-direction: column;
    }
    .startMgt-header {
        width: 100%;
        height: 40px;
        margin-bottom: 12px;
        display: flex;
        .el-input__icon {
            height: 36px ;
            line-height: 0!important;
        }
        .el-select,.el-select>.el-input,.el-button {
            height: 32px;
        }
        .el-select {
            width: 116px;
        }
        .el-select,.el-input {
            margin-right: 20px;
        }
    }
    .customerBox {
        display: flex;
        align-items: center;
        img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    /*表格操作样式*/
    .table-position {
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span {
            color: #409EFF;
            cursor: pointer;
        }
    }
    /*样式更改 日期选择*/
    .el-range-editor.el-input__inner {
        padding: 0 10px;
    }
    .topicIndex .el-date-editor {
        margin-right: 20px;
    }
</style>
